import React, { useEffect, useState, useCallback } from "react";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useTheme } from '@mui/material/styles';
import { useNavigate } from "react-router-dom";
import makeStyles from "@material-ui/styles/makeStyles";

import { updateBookFormSettings } from "../../../redux/actions/book";
import ConfirmModal from '../../../components/layout/ConfirmModal';
import DurationButton from "../../../components/layout/DurationButton";
import CustomLinkRow from "../../../components/layout/CustomLinkRow";
import { isValidHttpUrl } from "../../../utils/isValidHttpUrl";
import { isValidEmailAddress } from "../../../utils/isValidEmailAddress";
import "../../onboard/OnboardFormPage.style.css";

import CheckIcon from '@mui/icons-material/Check';
import AddIcon from "@mui/icons-material/Add";
import IMG_ID from "../../../assets/img/id-icon.png";
import IMG_PROVIDER_REFERENCES from "../../../assets/img/provider-reference.jpg";
import IMG_EMPLOYMENT_REFERENCES from "../../../assets/img/employment-reference.jpg";
import Particles from "react-particles";
import { loadFull } from "tsparticles";
import { loadConfettiPreset } from "tsparticles-preset-confetti";
import { loadHeartShape } from "tsparticles-shape-heart";
import { loadFireworksPreset } from "tsparticles-preset-fireworks";

import { CONFETTI_OPTIONS, FIREWORKS_OPTIONS, HEART_OPTIONS } from "../../booking/createBookingSubs/particleOptions";

const DURATION_HOURS = [1, 1.5, 2, 3, 4, 6, 8, 12, 24, 48, 72, 0];
const SELFIE_UPLOAD = ['Enable', 'Disable'];
const BOOK_FORM_THEME = ['Light', 'Dark'];
const DISPLAY_CONFETTI = ['None', 'Classic', 'Hearts', 'Fireworks'];

export default function FormSettings({ user, emailNotification }) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const [isIncallChecked, setIsIncallChecked] = useState(false);
  const [isOutcallChecked, setIsOutcallChecked] = useState(false);
  const [isFMTYChecked, setIsFMTYChecked] = useState(false);
  const [isSocialChecked, setIsSocialChecked] = useState(false);
  const [isVirtualChecked, setIsVirtualChecked] = useState(false);
  const [isMessageChecked, setIsMessageChecked] = useState(false);

  const [durationOptions, setDurationOptions] = useState([]);

  const [screeningOptions, setScreeningOptions] = useState(0);
  const [customLinks, setCustomLinks] = useState([]);

  const [isIDUpload, setIsIDUpload] = useState(false);
  const [isProviderReferences, setIsProviderPreferences] = useState(false);
  const [isEmploymentReferences, setIsEmploymentReferences] = useState(false);

  const [isSelfieUpload, setIsSelfieUpload] = useState('Enable');
  const [bookFormTheme, setBookFormTheme] = useState('Light');
  const [displayConfetti, setDisplayConfetti] = useState('None');

  const [effectConfetti, setEffectConfetti] = useState('');

  
  const particlesInit = useCallback(async engine => {
    // console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size

    await loadFull(engine);
    if (effectConfetti === 'Classic') {
      await loadConfettiPreset(engine);
    } else if (effectConfetti === 'Hearts') {
      await loadHeartShape(engine);
    } else if (effectConfetti === 'Fireworks') {
      await loadFireworksPreset(engine);
    }
  }, []);

  const particlesLoaded = useCallback(async container => {
    // console.log(container);
  }, []);

  function getParticleOptions() {
    if (effectConfetti === 'Classic') {
      return CONFETTI_OPTIONS;
    } else if (effectConfetti === 'Hearts') {
      return HEART_OPTIONS;
    } else if (effectConfetti === 'Fireworks') {
      return FIREWORKS_OPTIONS;
    }
    return {};
  }

  const [errors, setErrors] = useState({
    bookingTypes: false,
    durationOptions: false,
    screeningOptions: false,
  });
  const [modalVisible, setModalVisible] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);

  useEffect(() => {
    setIsIncallChecked(emailNotification?.bookingTypes?.incall || false);
    setIsOutcallChecked(emailNotification?.bookingTypes?.outcall || false);
    setIsFMTYChecked(emailNotification?.bookingTypes?.fmty || false);
    setIsSocialChecked(emailNotification?.bookingTypes?.social || false);
    setIsVirtualChecked(emailNotification?.bookingTypes?.virtual || false);
    setIsMessageChecked(emailNotification?.bookingTypes?.message || false);
    setDurationOptions([ ...(emailNotification?.durationOptions || []) ]);
    setIsIDUpload(emailNotification?.screeningOptions?.isIDUpload || false);
    setIsProviderPreferences(emailNotification?.screeningOptions?.isProviderReferences || false);
    setIsEmploymentReferences(emailNotification?.screeningOptions?.isEmploymentReferences || false);
    setCustomLinks([ ...(emailNotification?.customLinks || []) ]);
    setIsSelfieUpload(emailNotification?.selfieUpload ? 'Enable' : 'Disable');
    setBookFormTheme(emailNotification?.bookFormTheme ? 'Light' : 'Dark');
    setDisplayConfetti(emailNotification?.displayConfetti || 'None');
  }, [emailNotification]);

  useEffect(() => {
    if (emailNotification) {
      const count = (isIncallChecked ? 1 : 0) + (isOutcallChecked ? 1 : 0) + (isFMTYChecked ? 1 : 0) + (isSocialChecked ? 1 : 0) + (isVirtualChecked ? 1 : 0) + (isMessageChecked ? 1 : 0);
      let tempErrors = errors;
      tempErrors.bookingTypes = count < 1;
      setErrors({ ...tempErrors });
    }
  }, [isIncallChecked, isOutcallChecked, isFMTYChecked, isSocialChecked, isVirtualChecked, isMessageChecked]);
  useEffect(() => {
    if (emailNotification) {
      let tempErrors = errors;
      tempErrors.durationOptions = durationOptions.length < 3;
      setErrors({ ...tempErrors });
    }
  }, [durationOptions]);
  useEffect(() => {
    if (emailNotification) {
      let tempErrors = errors;
      tempErrors.screeningOptions = !(isIDUpload || isProviderReferences || isEmploymentReferences);
      setErrors({ ...tempErrors });
    }
  }, [isIDUpload, isProviderReferences, isEmploymentReferences]);

  const useStyles = makeStyles({
    menuItem: {
      color: theme.palette.mode === 'light' ? '#5e6278' : '#92929f',
      fontSize: '13px',
      "&:hover": {
        color: '#009ef7',
        backgroundColor: theme.palette.mode === 'light' ? '#f1faff' : '#212e48',
      },
    },
    menuItemSelected: {
      color: '#fff',
      backgroundColor: '#009ef7 !important',
      alignItems: 'center',
      justifyContent: 'space-between',
      "&:hover": {
        color: '#fff',
        backgroundColor: '#009ef7 !important',
      },
    },
  });
  const styles = useStyles();

  const onSubmitHandler = (e) => {
    if (errors.bookingTypes || errors.durationOptions || errors.screeningOptions) {
      return;
    }
    for (let i = 0; i < customLinks.length; i++) {
      if (customLinks[i].error) {
        return;
      }
    }
    setModalVisible(true);
  };

  const onCloseModal = () => {
    setModalVisible(false);
  }

  const onCloseConfirmModal = () => {
    setConfirmModalVisible(false);
  }

  function getDurationButtonTitle(duration) {
    if (duration === 0) {
      return "Custom";
    } else if (duration > 1) {
      return duration + " Hours";
    } else {
      return duration + " Hour";
    }
  }
  const onDurationButtonClicked = (e) => {
    let index = durationOptions.indexOf(e);
    let tempDurationOptions = durationOptions;
    if (index > -1) {
      tempDurationOptions.splice(index, 1);
    } else {
      tempDurationOptions.push(e);
    }
    setDurationOptions([ ...tempDurationOptions ]);
  }

  const onAddCustomRow = () => {
    if (customLinks.length > 9) {
      return;
    }
    const newRow = { label: '', labelPlaceholder: 'E.g. TER', value: '', placeholder: 'Enter URL address' };
    setCustomLinks([ ...customLinks, newRow ]);
  };
  const onRemoveCustomRow = (index) => {
    if (index < 3) { // Cannot remove website, email, twitter
      return;
    }
    let tempCustomLinks = customLinks;
    tempCustomLinks.splice(index, 1);
    setCustomLinks([ ...tempCustomLinks ]);
  }
  const onChangeCustomRowLabel = (index, value) => {
    let tempCustomLinks = customLinks;
    tempCustomLinks[index].label = value;
    setCustomLinks([ ...tempCustomLinks ]);
  }
  const onChangeCustomRowValue = (index, value) => {
    let tempCustomLinks = customLinks;
    tempCustomLinks[index].value = value;
    // Check validation when index = 1, check email, otherwise, check valid url
    tempCustomLinks[index].error = index === 1 ? !isValidEmailAddress(value) : !isValidHttpUrl(value);
    setCustomLinks([ ...tempCustomLinks ]);
  }

  const onSaveChanges = async () => {
    onCloseModal();
    const data = {
      bookFormId: user?.bookFormId,
      bookingTypes: {
        incall: isIncallChecked,
        outcall: isOutcallChecked,
        fmty: isFMTYChecked,
        social: isSocialChecked,
        virtual: isVirtualChecked,
        message: isMessageChecked,
      },
      durationOptions,
      screeningOptions: { isIDUpload, isProviderReferences, isEmploymentReferences },
      customLinks,
      selfieUpload: isSelfieUpload === 'Enable',
      bookFormTheme: bookFormTheme === 'Light',
      displayConfetti
    }; 
    const res = await dispatch(updateBookFormSettings(data));
    if (res) {
      setConfirmModalVisible(true);
    }
  }

  return (
    <>
      <Grid>
        <Typography sx={{ fontSize: '1.5rem', fontWeight: 700 }}>Form Preferences</Typography>
      </Grid>
      <Divider sx={{ mt: 2 }} />
      <Box
        display='flex'
        flexDirection='column'
        component='form'
        noValidate
        autoComplete='off'>
        <Grid container sx={{ mt: 3 }}>
          <Grid item xs={12} md={6}>
            <Typography sx={{ fontWeight: 600, fontSize: '16px', color: theme.palette.mode === 'light' ? '#181c32' : '#fff' }}>Booking Types</Typography>
            <Typography sx={{ fontWeight: 400, fontSize: '12px', maxWidth: '300px', color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6d80' }}>Select the types of appointments you offer.</Typography>
          </Grid>
          <Grid item container xs={12} md sx={{ mt: { xs: 1, md: 0 } }}>
            <Grid item xs={6} md={4}>
              <FormControlLabel
                value={isIncallChecked}
                label={<Typography sx={{ fontWeight: 500, fontSize: '14px', color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Incalls</Typography>}
                control={<Checkbox checked={isIncallChecked} />}
                onChange={e => setIsIncallChecked(prev => !prev)}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControlLabel
                value={isOutcallChecked}
                label={<Typography sx={{ fontWeight: 500, fontSize: '14px', color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Outcalls</Typography>}
                control={<Checkbox checked={isOutcallChecked} />}
                onChange={e => setIsOutcallChecked(prev => !prev)}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControlLabel
                value={isFMTYChecked}
                label={<Typography sx={{ fontWeight: 500, fontSize: '14px', color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>FMTY</Typography>}
                control={<Checkbox checked={isFMTYChecked} />}
                onChange={e => setIsFMTYChecked(prev => !prev)}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControlLabel
                value={isMessageChecked}
                label={<Typography sx={{ fontWeight: 500, fontSize: '14px', color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Duos/Couples</Typography>}
                control={<Checkbox checked={isMessageChecked} />}
                onChange={e => setIsMessageChecked(prev => !prev)}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControlLabel
                value={isSocialChecked}
                label={<Typography sx={{ fontWeight: 500, fontSize: '14px', color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Social</Typography>}
                control={<Checkbox checked={isSocialChecked} />}
                onChange={e => setIsSocialChecked(prev => !prev)}
              />
            </Grid>
            <Grid item xs={6} md={4}>
              <FormControlLabel
                value={isVirtualChecked}
                label={<Typography sx={{ fontWeight: 500, fontSize: '14px', color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Virtual</Typography>}
                control={<Checkbox checked={isVirtualChecked} />}
                onChange={e => setIsVirtualChecked(prev => !prev)}
              />
            </Grid>
          </Grid>
          {errors.bookingTypes && <Typography sx={{ color: '#f1416c', fontSize: '12px' }}>You need to select at least 1 booking type.</Typography>}
        </Grid>
        <Grid container sx={{ mt: 3 }}>
          <Grid item xs={12} md={6}>
            <Typography sx={{ fontWeight: 600, fontSize: '16px', color: theme.palette.mode === 'light' ? '#181c32' : '#fff' }}>Duration</Typography>
            <Typography sx={{ fontWeight: 400, fontSize: '12px', maxWidth: '300px', color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6d80' }}>Select the appointment durations you offer.</Typography>
          </Grid>
          <Grid item container xs={12} md spacing={2} sx={{ mt: { xs: 0, md: 0 } }}>
            {DURATION_HOURS.map((duration, index) => (
              <Grid key={index} item xs={6} md={4}>
                <DurationButton
                  onClick={() => onDurationButtonClicked(duration)}
                  title={getDurationButtonTitle(duration)}
                  selected={durationOptions.includes(duration)}
                />
              </Grid>
            ))}
          </Grid>
          {errors.durationOptions && <Typography sx={{ color: '#f1416c', fontSize: '12px', mt: 1 }}>You need to select at least 3 items</Typography>}
        </Grid>
        <Grid container sx={{ mt: 3 }}>
          <Grid item xs={12} md={6}>
            <Typography sx={{ fontWeight: 600, fontSize: '16px', color: theme.palette.mode === 'light' ? '#181c32' : '#fff' }}>Screening Options</Typography>
            <Typography sx={{ fontWeight: 400, fontSize: '12px', maxWidth: '300px', color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6d80' }}>Select your screening options.</Typography>
          </Grid>
          <Grid item container xs={12} md spacing={2} sx={{ mt: 0 }}>
            <Grid item md={4}>
              <Box
                onClick={() => {
                  setIsIDUpload(prev => !prev);
                  setScreeningOptions(0);
                }}
                component="img"
                src={IMG_ID}
                sx={{ width: '90%', border: screeningOptions === 0 ? '2px solid #009ef7' : 'none', borderRadius: '8px' }}
                alt="IMG_ID"
              />
              <FormControlLabel
                value={isIDUpload}
                label={<Typography sx={{ fontSize: '12px', color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>ID Upload (default)</Typography>}
                control={<Checkbox checked={isIDUpload} />}
                onChange={e => setIsIDUpload(prev => !prev)}
              />
            </Grid>
            <Grid item md={4}>
              <Box
                onClick={() => {
                  setIsProviderPreferences(prev => !prev);
                  setScreeningOptions(1);
                }}
                component="img"
                src={IMG_PROVIDER_REFERENCES}
                sx={{ width: '90%', border: screeningOptions === 1 ? '2px solid #009ef7' : 'none', borderRadius: '8px' }}
                alt="IMG_PROVIDER_REFERENCES"
              />
              <FormControlLabel
                xs={4}
                value={isProviderReferences}
                label={<Typography sx={{ fontSize: '12px', color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Provider References</Typography>}
                control={<Checkbox checked={isProviderReferences} />}
                onChange={e => setIsProviderPreferences(prev => !prev)}
              />
            </Grid>
            <Grid item md={4}>
              <Box
                onClick={() => {
                  setIsEmploymentReferences(prev => !prev);
                  setScreeningOptions(2);
                }}
                component="img"
                src={IMG_EMPLOYMENT_REFERENCES}
                sx={{ width: '90%', border: screeningOptions === 2 ? '2px solid #009ef7' : 'none', borderRadius: '8px' }}
                alt="IMG_EMPLOYMENT_REFERENCES"
              />
              <FormControlLabel
                xs={4}
                value={isEmploymentReferences}
                label={<Typography sx={{ fontSize: '12px', color: theme.palette.mode ==="light" ? "#181c32" : "#fff" }}>Employment References</Typography>}
                control={<Checkbox checked={isEmploymentReferences} />}
                onChange={e => setIsEmploymentReferences(prev => !prev)}
              />
            </Grid>
          </Grid>
          {errors.screeningOptions && <Typography sx={{ color: '#f1416c', fontSize: '12px', mt: 1 }}>You must select at least 1 screening method.</Typography>}
        </Grid>
        <Grid container sx={{ mt: 3 }}>
          <Grid item xs={12} md={6}>
            <Typography sx={{ fontWeight: 600, fontSize: '16px', color: theme.palette.mode === 'light' ? '#181c32' : '#fff' }}>Custom Links</Typography>
            <Typography sx={{ fontWeight: 400, fontSize: '12px', maxWidth: '300px', color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6d80' }}>Your personal links will show on your booking form sidebar and Perks page for easy reference.</Typography>
          </Grid>
          <Grid item container xs={12} md sx={{ mt: 0 }}>
            {customLinks.map((e, index) => (
              <CustomLinkRow
                key={index}
                index={index}
                label={e.label}
                labelPlaceholder={e.labelPlaceholder}
                placeholder={e.placeholder}
                value={e.value}
                staticRow={e.staticRow}
                error={e.error}
                onRemoveCustomRow={onRemoveCustomRow}
                onChangeCustomRowLabel={onChangeCustomRowLabel}
                onChangeCustomRowValue={onChangeCustomRowValue}
              />
            ))}
            <Button
              onClick={onAddCustomRow}
              variant="contained"
              color="primary"
              sx={{
                mt: 2,
                backgroundColor: theme.palette.mode === "light" ? "#f1faff" : "#212e48",
                padding: '10px 20px',
                color: '#009ef7',
                fontSize: '13px',
                fontWeight: 500,
                textTransform: 'none',
                '&:hover ': {
                  backgroundColor: "#009ef7",
                  color: '#fff',
                }
              }}>
              <AddIcon /> Add
            </Button>
          </Grid>
        </Grid>
        <Grid container alignItems="center" sx={{ mt: 3 }}>
          <Grid item xs={12} md={6}>
            <Typography sx={{ fontWeight: 600, fontSize: '16px', color: theme.palette.mode === 'light' ? '#181c32' : '#fff' }}>Selfie Upload?</Typography>
            <Typography sx={{ fontWeight: 400, fontSize: '12px', maxWidth: '300px', color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6d80' }}>Allow client to upload a selfie, Increases screening security</Typography>
          </Grid>
          <Grid item xs={12} md sx={{ mt: { xs: 1, md: 0 } }}>
            <Select
              fullWidth
              inputProps={{ sx: { color: '#5e6278', fontWeight: 600 } }}
              displayEmpty={true}
              value={isSelfieUpload}
              renderValue={value => value ? value : 'Select ...'}
              sx={{ padding: 0, '.MuiSelect-select': { padding: '12px 20px' }, '.MuiOutlinedInput-notchedOutline': { borderStyle: 'none' } }}
              onChange={(e) => setIsSelfieUpload(e.target.value)}>
              {SELFIE_UPLOAD.map((e, index) => (
                <MenuItem
                  key={index}
                  value={e}
                  classes={{ root: styles.menuItem, selected: styles.menuItemSelected }}>
                  {e}
                  {e === isSelfieUpload && <CheckIcon style={{ width: '15px', height: '15px' }} />}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
        <Grid container alignItems="center" sx={{ mt: 3 }}>
          <Grid item xs={12} md={6}>
            <Typography sx={{ fontWeight: 600, fontSize: '16px', color: theme.palette.mode === 'light' ? '#181c32' : '#fff' }}>Light/Dark Mode</Typography>
            <Typography sx={{ fontWeight: 400, fontSize: '12px', maxWidth: '300px', color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6d80' }}>Choose the default display for your form</Typography>
          </Grid>
          <Grid item xs={12} md sx={{ mt: { xs: 1, md: 0 } }}>
            <Select
              fullWidth
              inputProps={{ sx: { color: '#5e6278', fontWeight: 600 } }}
              displayEmpty={true}
              value={bookFormTheme}
              renderValue={value => value ? value : 'Select ...'}
              sx={{ padding: 0, '.MuiSelect-select': { padding: '12px 20px' }, '.MuiOutlinedInput-notchedOutline': { borderStyle: 'none' } }}
              onChange={(e) => setBookFormTheme(e.target.value)}>
              {BOOK_FORM_THEME.map((e, index) => (
                <MenuItem
                  key={index}
                  value={e}
                  classes={{ root: styles.menuItem, selected: styles.menuItemSelected }}>
                  {e}
                  {e === bookFormTheme && <CheckIcon style={{ width: '15px', height: '15px' }} />}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
        <Grid container alignItems="center" sx={{ mt: 3 }}>
          <Grid item xs={12} md={6}>
            <Typography sx={{ fontWeight: 600, fontSize: '16px', color: theme.palette.mode === 'light' ? '#181c32' : '#fff' }}>Display Confetti?</Typography>
            <Typography sx={{ fontWeight: 400, fontSize: '12px', maxWidth: '300px', color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6d80' }}>Show a splash of color upon successfully submitting booking request.</Typography>
          </Grid>
          <Grid item xs={12} md sx={{ mt: { xs: 1, md: 0 } }}>
            <Select
              fullWidth
              inputProps={{ sx: { color: '#5e6278', fontWeight: 600 } }}
              displayEmpty={true}
              value={displayConfetti}
              renderValue={value => value ? value : 'Select ...'}
              sx={{ padding: 0, '.MuiSelect-select': { padding: '12px 20px' }, '.MuiOutlinedInput-notchedOutline': { borderStyle: 'none' } }}
              onChange={(e) => {
                setDisplayConfetti(e.target.value);
                setEffectConfetti(e.target.value);
              }}>
              {DISPLAY_CONFETTI.map((e, index) => (
                <MenuItem
                  key={index}
                  value={e}
                  classes={{ root: styles.menuItem, selected: styles.menuItemSelected }}
                >
                  {e}
                  {e === displayConfetti && <CheckIcon style={{ width: '15px', height: '15px' }} />}
                </MenuItem>
              ))}
            </Select>
          </Grid>
        </Grid>
        <Divider sx={{ mt: 2 }} />
        <Box display="flex" justifyContent="flex-end" sx={{ mt: 3 }}>
          <Button
            onClick={() => navigate('/bookings')}
            size="large"
            sx={{
              backgroundColor: theme.palette.mode === 'light' ? '#f5f8fa' : '#2b2b40',
              color: theme.palette.mode === 'light' ? '#7e8299' : '#6d6d80',
              fontWeight: 500,
              textTransform: 'none',
              borderRadius: '6px',
              padding: '11px 20px',
              "&:hover": {
                backgroundColor: theme.palette.mode === 'light' ? '#f1faff' : '#212E48',
                color: '#009ef7',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onSubmitHandler}
            size="large"
            sx={{ marginInlineStart: 1, color: '#fff', fontWeight: 600, textTransform: 'none' }}
          >
            Save Changes
          </Button>
        </Box>
      </Box>
      <ConfirmModal
        visible={modalVisible}
        onClose={onCloseModal}
        symbol="?"
        title="Apply changes?"
        description="Your profile will be updated with these new settings."
        titleYes="Confirm"
        titleNo="Cancel"
        onClickYes={onSaveChanges}
        onClickNo={onCloseModal}
      />
      <ConfirmModal
        visible={confirmModalVisible}
        onClose={onCloseConfirmModal}
        symbol="&#10004;"
        title="Success!"
        description="Your settings have been saved."
        titleNo="Continue"
        onClickNo={onCloseConfirmModal}
      />

    </>
  );
}
